<template>
  <div>
    <div class="wrap" v-if="show && identifier"></div>

    <!-- start 底部弹框 -->
    <!-- <transition
      enter-active-class="animated slideInUp"
      leave-active-class="animated slideOutDown"
    > -->
    <div class="cPopup" v-if="show && position === 'bottom' && type === 'bottom' && identifier" @click.stop="close($event)">
      <div class="pPopup_bottom">
        <div class="btnGroup">
          <div class="close" @click="close">{{ cancelText ? cancelText : '取消' }}</div>
          <div class="center">{{ centerText }}</div>
          <div class="confirm" @click="comfirm">{{ confirmText ? confirmText : '确定' }}</div>
        </div>
        <slot name="content"></slot>
      </div>
    </div>
    <!-- </transition> -->
    <!-- end 底部弹框 -->

    <!-- start 中央弹框 -->
    <!-- <transition
      enter-active-class="animated bounceIn"
      leave-active-class="animated bounceOut"
    > -->
    <div class="cPopup" v-if="show && position === 'center' && type === 'center'">
      <div class="pPopup_center">
        <div class="content">
          <div class="contentWrap">
            <slot name="content"></slot>
          </div>
          <div class="btnGroup" :class="confirmFlex ? 'confirmFlex' : ''">
            <div class="cancel" @click="close">{{ cancelText ? cancelText : '取消' }}</div>
            <div class="comfirm" @click="comfirm">{{ confirmText ? confirmText : '确定' }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- </transition> -->
    <!-- end 中央弹框 -->
  </div>
</template>

<script>
export default {
  props: ['position', 'identifier', 'centerText', 'cancelText', 'confirmText', 'confirmFlex'],
  computed: {
    show() {
      return this.$store.state.popup.show
    },
    type() {
      return this.$store.state.popup.type
    }
  },
  methods: {
    close($event) {
      let classArr = ['cPopup', 'close', 'cancel']
      if (classArr.indexOf($event.target.className) > -1) {
        this.$store.commit('set_popup_show', false)
      }
      this.$emit('close')
    },
    comfirm() {
      this.$emit('confirm')
    }
  },
  destroyed() {
    this.$store.commit('set_popup_show', false)
  }
}
</script>

<style lang="less" scoped>
@import '../styles/base.less';
.wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
}
.cPopup {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 300;
}
// 底部弹框
.pPopup_bottom {
  padding: 1em;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 1000;
  .btnGroup {
    > div {
      display: inline-block;
      padding: 0.5em 0 1em;
    }
    .confirm {
      padding-left: 2em;
    }
    .close {
      padding-right: 2em;
    }
  }
}
// 中央弹框
.pPopup_center {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 500;
  .content {
    width: 70%;
    /*max-height: 5rem;*/
    background-color: #fff;
    border-radius: 0.4em;
  }
  &.confirmFlex {
    .btnGroup {
      .comfirm {
        flex: 1;
      }
    }
  }

  &:not(.confirmFlex) {
    .btnGroup {
      display: -webkit-box;
      > div {
        flex: 1;
      }
    }
  }

  .contentWrap {
    max-height: 7rem;
    overflow: hidden;
    overflow-y: auto;
    /*line-height: 1.8em;*/
    font-size: 1.2em;
    padding: 1em;
    &::-webkit-scrollbar-track-piece {
      background-color: rgba(0, 0, 0, 0);
      border-left: 1px solid rgba(0, 0, 0, 0);
    }
    &::-webkit-scrollbar {
      width: 5px;
      height: 13px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.5);
      background-clip: padding-box;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
      min-height: 28px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: rgba(0, 0, 0, 0.5);
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      border-radius: 5px;
    }
  }

  .btnGroup {
    display: flex;
    justify-content: space-around;
    align-content: center;
    text-align: center;
    > div {
      border-top: 1px solid @bd_color;
      padding: 1em;
    }
    .cancel {
      border-right: 1px solid @bd_color;
      background-color: @bg_color;
      border-radius: 0 0 0 0.4em;
    }
    .comfirm {
      color: #fff;
      background-color: @main_color;
      border-radius: 0 0 0.4em 0;
    }
  }
}

.btnGroup {
  display: flex;
  justify-content: space-between;
  font-size: 1.2em;
  .close {
    color: #aaaeb6;
  }
  .confirm {
    color: @brand-color;
  }
}

.popup-enter,
.popup-leave-to {
  transform: translateX(10px);
}
.popup-enter-active,
.popup-leave-active {
  transition: all 0.3s ease;
}
</style>
